

export default {
  data() {
    return {
      autoUpdate: true,     // auto-update 
      updateExists: false,  // new contents available
      registration: null,   // object
      refreshing: false,    // Prevent multiple refreshes
    }
  },
  created() {
    // Listen for our custom event from the SW registration
    document.addEventListener('swUpdated', this.updateAvailable, { once: true });

    // Prevent multiple refreshes
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (this.refreshing) return;
      this.refreshing = true;
      // Here the actual reload of the page occurs
      window.location.reload();
    });
  },
  methods: {
    updateAvailable(event) { 
      // console.log(event);
      this.registration = event.detail;
      if (this.autoUpdate) {
        this.refreshApp();
      } else {
        this.updateExists = true;
      }
    },
    refreshApp() {
      this.updateExists = false;
      // Make sure we only send a 'skip waiting' message if the SW is waiting
      if (!this.registration || !this.registration.waiting) return;
      console.log("updating ...");
      // Send message to SW to skip the waiting and activate the new SW
      this.registration.waiting.postMessage({ type: "SKIP_WAITING" });
    },
  }
};